import { makeStyles } from '@mui/styles';

export const useSwitchSpaceActionStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: '16px 24px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 60px - 68px)',
      '@supports (height: 100svh)': {
        height: 'calc(100svh - 60px - 68px)'
      }
    }
  },
  actionButton: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '4px',
      paddingRight: '4px',
      height: '36px'
    }
  },
  dialogContentFullHeight: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  dialogContentFullHeightCentered: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: '24px'
  },
  dialogActions: {
    borderTop: '1px solid #EBEDF2',
    padding: '16px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-evenly'
    }
  },
  dialogActionsEmpty: {
    height: '68px'
  },
  dialogContentSpinnerTitle: {
    marginTop: '24px',
    textAlign: 'center',
    fontWeight: 600
  },
  dialogContentSpinnerMessage: {
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: 1.5
  }
}));
